<template>
    <crud-facecade
        :url="url"
        :columns="columnList"
        :buttons="buttons"
        :tableHeight="tableHeight"
        v-wechat-title="title"
        :addButton="{ permission: 'permission:create' }"
        :deleteButton="{ permission: 'permission:update' }"
        :updateButton="{ permission: 'permission:delete' }"
    >
    </crud-facecade>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `OrganizationOperationWard`,
    props: {

    },
    data() {
        return {
            title: `组织架构-手术区`,
            // url: "/api/AcisSystem/OperatingWard",
            url: { baseURL: `/api/AcisSystem/OperatingWard`,
                get: () => {
                    return new Promise((resolve, reject) => {
                        let req = this.myaxios.get(`/api/AcisSystem/OperatingWard/Get`)
                        req.then(data => {
                            resolve(_.filter(data, d => {
                                return _.some(this.hospital_ward_auth, { value: d.dic_hospital_ward_id })
                            }))
                        }).catch(e => reject(e))
                    })
                },
                put: (row) => {
                    // ACIS-24310 手术区设置，默认科室项目无法清空
                    row.oper_section_id = row.oper_section_id || `-1`
                    row.anes_section_id = row.anes_section_id || `-1`
                    row.drug_section_id = row.drug_section_id || `-1`
                    row.drug_oper_section_id = row.drug_oper_section_id || `-1`
                    return this.myaxios.put(`/api/AcisSystem/OperatingWard/Put`, row)
                }
            },
            buttons: []
        }
    },
    created() {
    },
    computed: {
        ...mapGetters([`hospital_ward_auth`, `section`, `screenHeight`]),
        tableHeight() {
            return this.screenHeight && (this.screenHeight - 190) || 0
        },
        columnList() {
            return [{
                type: `string`,
                prop: `id`,
                label: `编号`,
                // width: "180",
                isListable: false,
                isExpand: false,
                isEditable: false,
                isCreatable: false,
                isKey: true
            }, {
                type: `number`,
                prop: `display_order`,
                label: `排序`,
                width: `180`,
                isListable: true,
                isExpand: false,
                isEditable: false,
                isCreatable: false,
                readonly: false,
                sortable: true,
                isDisplayOrder: true
            }, {
                type: `string`,
                prop: `code`,
                label: `编码`,
                width: `100`,
                isListable: true,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                searchable: true,
                sortable: true,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            }, {
                type: `string`,
                prop: `name`,
                label: `名称`,
                width: `180`,
                isListable: true,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                searchable: true,
                sortable: true,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            }, {
                type: `select`,
                prop: `dic_hospital_ward_id`,
                label: `院区`,
                width: `180`,
                isListable: true,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                searchable: true,
                sortable: true,
                options: this[`hospital_ward_auth`],
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            }, {
                type: `string`,
                prop: `abbr`,
                label: `缩写`,
                width: `100`,
                isListable: false,
                isExpand: false,
                isEditable: false,
                isCreatable: false,
                searchable: false,
                sortable: false
            }, {
                type: `string`,
                prop: `description`,
                label: `描述`,
                isListable: true,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                searchable: true,
                sortable: true
            }, {
                type: `multiselect`,
                prop: `anes_section_id_arr`,
                label: `麻醉计费默认科室`,
                width: `180`,
                isListable: true,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                searchable: true,
                sortable: true,
                options: this.section
            }, {
                type: `multiselect`,
                prop: `oper_section_id_arr`,
                label: `手术计费默认科室`,
                width: `180`,
                isListable: true,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                searchable: true,
                sortable: true,
                options: this.section
            }, {
                type: `multiselect`,
                prop: `drug_section_id_arr`,
                label: `麻醉计费默认药房`,
                width: `180`,
                isListable: true,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                searchable: true,
                sortable: true,
                options: this.drugSections
            }, {
                type: `multiselect`,
                prop: `drug_oper_section_id_arr`,
                label: `手术计费默认药房`,
                width: `180`,
                isListable: true,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                searchable: true,
                sortable: true,
                options: this.drugSections
            }, {
                type: `rbool`,
                prop: `is_deleted`,
                label: `状态`,
                width: `70`,
                isListable: true,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                searchable: true,
                sortable: false,
                readonly: false,
                options: `is_enabled`,
                default: false
            }, {
                type: `select`,
                prop: `is_endoscopy`,
                label: `内镜检查室`,
                width: `80`,
                isListable: true,
                isEditable: true,
                isCreatable: true,
                isExpand: false,
                searchable: false,
                sortable: false,
                options: `enum_bool`
            }]
        },
        drugSections() {
            let all = this[`section`]
            if (all && all.length > 0) {
                var yaofang = []
                let other = []
                for (let item of all) {
                    if (!item.disabled) {
                        if (item.label.indexOf(`药房`) >= 0) {
                            yaofang.push(item)
                        } else {
                            other.push(item)
                        }
                    }
                }
                return yaofang.concat(other)
            }
            return []
        }
    },
    mounted() {
        this.$store.dispatch(`ADD_SECTION_AUTH`)
        this.$store.dispatch(`ADD_SECTION`)
    },
    methods: {

    }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Organization/OperationWard/Index.vue